import { i18n } from '@/i18n'

const { t: $t } = i18n.global

export const GENERAL_TAB_KEY = 'general' as const
export const DOCUMENTS_TAB_KEY = 'documents' as const
export const COORDINATOR_TAB_KEY = 'coordinator' as const
export const REQUISITES_TAB_KEY = 'requisites' as const
export const SERVICES_TAB_KEY = 'services' as const
export const DOCTORS_TAB_KEY = 'doctors' as const
export const MEDIA_TAB_KEY = 'media' as const
export const SCHEDULE_TAB_KEY = 'schedule' as const
export const MODERATION_TAB_KEY = 'moderation' as const
export const PUBLICATION_TAB_KEY = 'publication' as const

export const FACILITY_TABS_TITLES = {
  [GENERAL_TAB_KEY]: $t('General info'),
  [DOCUMENTS_TAB_KEY]: $t('Documents'),
  [COORDINATOR_TAB_KEY]: $t('Coordinator'),
  [REQUISITES_TAB_KEY]: $t('Requisites'),
  [SERVICES_TAB_KEY]: $t('Services'),
  [DOCTORS_TAB_KEY]: $t('Doctors'),
  [MEDIA_TAB_KEY]: $t('Media'),
  [SCHEDULE_TAB_KEY]: $t('Schedule'),
  [MODERATION_TAB_KEY]: $t('Moderation'),
  [PUBLICATION_TAB_KEY]: $t('Publication'),
}
export const FACILITY_CREATION_STEPS_HINT = {
  [GENERAL_TAB_KEY]: {
    title: $t('Step 1. Medical facility profile'),
    desc: $t('Add basic information about your medical facility that will be displayed to users on your profile page.'),
  },
  [DOCUMENTS_TAB_KEY]: {
    title: $t('Step 2. License'),
    desc: $t('Add license information and upload documents to prove your activity.'),
  },
  [COORDINATOR_TAB_KEY]: {
    title: $t('Step 3. Coordinators'),
    desc: $t('Add responsible persons to manage the profile.'),
  },
  [REQUISITES_TAB_KEY]: {
    title: $t('Step 4. Contract'),
    desc: $t('Read the terms of cooperation and sign an agreement to connect to the platform.'),
  },
  [MODERATION_TAB_KEY]: {
    title: $t('Step 5. Moderation'),
    desc: $t('Expect information verification before publishing your profile on the platform.'),
  },
  [PUBLICATION_TAB_KEY]: {
    title: $t('Step 6. Publish'),
    desc: $t('Publish your profile so that it is available to platform users.'),
  },
}

export enum ScheduleStatus {
  open = 'open',
  close = 'close',
}

export enum ServiceStatuses {
  DRAFT = 'draft',
  ACTIVE = 'active',
  ARCHIVE = 'archive',
}
export const SERVICES_STATUSES = [
  {
    value: ServiceStatuses.DRAFT,
    label: $t('Draft'),
  },
  {
    value: ServiceStatuses.ACTIVE,
    label: $t('Active'),
  },
  {
    value: ServiceStatuses.ARCHIVE,
    label: $t('Archive'),
  },
]

export enum BranchJoinStatuses {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  STOPPED = 'stopped',
}
export enum PublicationStatus {
  ACTIVE = 'active',
  DRAFT = 'draft',
  ARCHIVE = 'archive',
}

export enum StatusModerationChoices {
  DRAFT = 'draft',
  AWAITING_MODERATION = 'awaiting_moderation',
  UNDER_MODERATION = 'under_moderation',
  ACTIVE = 'active',
  ARCHIVE = 'archive',
}

export const GET_MODERATION_STATUSES = (t) => [
  {
    value: StatusModerationChoices.DRAFT,
    label: t('In process of filling out information'),
    icon: 'i-status-process',
    color: '#B81ED1',
  },
  {
    value: StatusModerationChoices.AWAITING_MODERATION,
    label: t('The medical facility is waiting for moderation to begin'),
    icon: 'i-status-waiting-moderation',
    color: '#6782F6',
  },
  {
    value: StatusModerationChoices.UNDER_MODERATION,
    label: t('The medical facility is being checked'),
    icon: 'i-status-check',
    color: '#FFA31A',
  },
  // {
  //   value: StatusModerationChoices.WAITING_SIGNED_CONTRACT,
  //   label: t('Waiting for the contract to be signed'),
  //   icon: 'i-status-waiting-sign',
  //   color: '#6782F6',
  // },
  {
    value: StatusModerationChoices.ACTIVE,
    label: t('Medical facility activated'),
    icon: 'i-status-active',
    color: '#1ED1AC',
  },
  // {
  //   value: StatusModerationChoices.NOT_SUCCESSFUL,
  //   label: t('Moderation was not successful'),
  //   icon: 'i-status-failed',
  //   color: '#E74C3C',
  // },
  {
    value: StatusModerationChoices.ARCHIVE,
    label: t('Account is archive'),
    icon: 'i-status-blocked',
    color: '#E74C3C',
  },
]

export const ckeditorConfig = {
  // 'undo', 'redo', '|',
  toolbar: ['heading', '|', 'bold', 'italic', '|', 'link'],
}

export enum PLACE_WORK_STATUSES {
  PENDING_REVIEW_DOCTOR = 'pending_review_doctor',
  PENDING_REVIEW_MEDICAL = 'pending_review_medical',
  ACCEPTED = 'accepted',
  DISCONTINUED = 'discontinued',
  REJECTED_DOCTOR = 'rejected_doctor',
  REJECTED_MEDICAL = 'rejected_medical',
}


export enum CommissionMethods {
  PERCENTAGE = 'percentage',
  FIXED = 'fixed',
}

export const commissionMethods = [
  {
    title: $t('Percentage'),
    value: CommissionMethods.PERCENTAGE,
  },
  {
    title: $t('Fixed'),
    value: CommissionMethods.FIXED,
  },
]

export const SIGN_BY_COMMISSION_METHOD_MAP = {
  [CommissionMethods.PERCENTAGE]: '%',
  [CommissionMethods.FIXED]: '₴',
}